import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Space, Popover, Tooltip, Upload } from 'antd';
import { connect } from 'react-redux';
import {
	Button,
	Input,
	notification,
	Affix,
	List,
	Checkbox,
	Radio,
	Card,
	Image,
	Progress,
} from 'antd';
import {
	UploadOutlined,
	CopyOutlined,
	DownloadOutlined,
	DeleteOutlined,
	LinkOutlined,
	ArrowUpOutlined,
	FileTextOutlined,
	UpCircleTwoTone,
} from '@ant-design/icons';
import axios from 'axios';
import Header from '../../components/Header/Header';
import HeaderFile from '../../components/Header/HeaderFile';
import {
	XThemeForm,
	XThemeModal,
	XSelect,
	XRoundButton,
	XModalTitle,
	XModalSubtitle,
	XList,
	XCircle,
	XLabel,
} from '../../styles/GlobalThemeStyle';

import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';
import {
	DeIdentifyDesktopBody,
	XTitleHeader,
	XLottieShieldMaxx,
	ParaShieldMaxx,
	XShieldMaxxTitle,
	XInputTextArea,
	XDivider,
	ActionButton,
	ActionButtonGroup,
	XDeIdentifyBtn,
	XThemShieldDesktop,
	XTextAreaShieldMaxx,
	XTextAreaShieldMaxxBTN,
	ParaShieldLeftScrollWrapper,
	XShieldRightScrollCard,
	XProgressShieldRight,
	XThemeShieldLoader,
	XShieldSuggestionBTN,
} from './ShieldMaxxStyle';
import LoaderJson from '../../json/Reclaim.json';
import { getUserToken } from '../../utils/helper';
import config from '../../config';
import { deIdentifyApi, deIdentifyReset } from '../../actions/deIdentifyAction';
import { XThemeContainer } from '../../styles/GlobalThemeStyleCQ';
import { Link } from 'react-router-dom';

const { TextArea } = Input;
const { Dragger } = Upload;

const ShieldMaxx = (props) => {
	const { deIdentify, deIdentifyReset, deIdentifyState } = props;

	// State variables
	const [loading, setLoading] = useState(false);
	const [form] = XThemeForm.useForm();
	const [inputText, setInputText] = useState('');
	const [deIdentifiedText, setDeIdentifiedText] = useState('');
	const [deIdentifiedUrl, setDeIdentifiedUrl] = useState('');
	const [isProcessing, setIsProcessing] = useState(false);
	const [progress, setProgress] = useState(0);
	const progressInterval = useRef(null);
	const [isProcess, setIsProcess] = useState(true);
	const [isDisabled, setIsDisabled] = useState(false);
	const [clinicalDocumentFileList, setClinicalDocumentFileList] = useState(
		[],
	);
	const [uploadedS3Url, setUploadedS3Url] = useState('');

	// Handle text input change
	const handleInputChange = (e) => {
		setInputText(e.target.value);
	};

	// Handle file upload to S3
	const handleFileUploadToS3 = async (file) => {
		try {
			let get_ext = file.name.split('.');
			let ext = get_ext[get_ext.length - 1];
			const timestamp = new Date().getTime();

			console.log('Uploading file:', file.name, 'with extension:', ext);

			// Get signed URL for S3 upload
			const res = await axios.get(
				`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=uploads/de-id/input&file_name=${timestamp}&ext=${ext}`,
				{
					headers: {
						'Content-type': 'application/json; charset=UTF-8',
						Authorization: 'Bearer ' + getUserToken(),
					},
				},
			);

			console.log('Signed URL response:', res.data);

			// Upload file to S3
			const result = await axios.put(res.data.data, file);

			if (result.status === 200) {
				let documentPath = '';
				if (res.data.data) {
					documentPath = res.data.data.split('?')[0];
				}
				console.log('S3 upload successful, document path:', documentPath);
				setUploadedS3Url(documentPath);
				return documentPath;
			}
			return null;
		} catch (error) {
			console.error('S3 upload error:', error);
			notification.error({
				message: 'Error',
				description: 'Failed to upload file to S3. Please try again.',
			});
			return null;
		}
	};

	// Handle file upload change
	const handleFileUploadChange = ({ fileList: newFileList }) => {
		setInputText('');
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setClinicalDocumentFileList(updatedFileList);
		setIsDisabled(true);
	};

	// Handle file upload
	const handleFileUpload = async (file) => {
		try {
			const s3Url = await handleFileUploadToS3(file);
			if (s3Url) {
				notification.success({
					message: 'Success',
					description: 'File uploaded successfully to S3.',
				});
			} else {
				notification.error({
					message: 'Error',
					description: 'Failed to upload file to S3. Please try again.',
				});
			}
		} catch (error) {
			notification.error({
				message: 'Error',
				description: 'Failed to process the file. Please try again.',
			});
		}
	};

	// Copy to clipboard
	const handleCopy = async (text) => {
		try {
			await navigator.clipboard.writeText(text);
			notification.success({
				message: 'Copied',
				description: 'Text copied to clipboard successfully.',
			});
		} catch (error) {
			notification.error({
				message: 'Error',
				description: 'Failed to copy text. Please try again.',
			});
		}
	};

	// Clear text
	const handleClear = (type) => {
		setInputText('');
		setDeIdentifiedText('');
		setDeIdentifiedUrl('');
		setIsDisabled(false);
		setIsProcess(true);
		setClinicalDocumentFileList([]);
		setUploadedS3Url('');
	};

	// Start progress simulation
	const startProgress = () => {
		setProgress(0);
		progressInterval.current = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 90) {
					clearInterval(progressInterval.current);
					return 90;
				}
				return prev + 10;
			});
		}, 500);
	};

	// Handle de-identification process
	const handleDeIdentify = async () => {
		setIsProcess(false);
		if (!inputText.trim() && !uploadedS3Url) {
			notification.warning({
				message: 'Input Required',
				description:
					'Please enter text or upload a file to de-identify.',
			});
			return;
		}

		setIsProcessing(true);
		startProgress();

		const payload = {
			text: inputText,
			document_url: uploadedS3Url || null,
		};

		console.log('De-identify payload:', payload);
		console.log('API Base URL:', config.api.base_url);
		console.log('Uploaded S3 URL:', uploadedS3Url);

		deIdentify(payload);
	};

	// Handle API response
	useEffect(() => {
		if (deIdentifyState.apiState === 'success') {
			setProgress(100);

			if (deIdentifyState.data.url) {
				setDeIdentifiedUrl(deIdentifyState.data.url);
			} else {
				setDeIdentifiedText(deIdentifyState.data.data);
			}
			notification.success({
				message: 'Success',
				description: 'Text has been successfully de-identified.',
			});
			setIsProcessing(false);
			deIdentifyReset();
		}

		if (deIdentifyState.apiState === 'error') {
			setIsProcessing(false);
			notification.error({
				message: 'Error',
				description:
					deIdentifyState.message ||
					'De-identification failed. Please try again.',
			});
			deIdentifyReset();
		}
	}, [deIdentifyState]);

	// Cleanup on unmount
	useEffect(() => {
		return () => {
			if (progressInterval.current) {
				clearInterval(progressInterval.current);
			}
		};
	}, []);

	// Handle file removal
	const handleRemoveFile = () => {
		setInputText('');
		setDeIdentifiedText('');
		setDeIdentifiedUrl('');
		setIsDisabled(false);
		setIsProcess(true);
		setClinicalDocumentFileList([]);
		setUploadedS3Url('');
	};

	// const uploadProps = {
	// 	name: 'file',
	// 	multiple: false,
	// 	accept: '.txt,.pdf,.docx,.doc,.xlsx,.xls',
	// 	beforeUpload: handleFileUpload,
	// 	onChange: handleFileUploadChange,
	// 	showUploadList: true,
	// 	maxCount: 1,
	// };

	const uploadProps = {
		name: 'file',
		multiple: false,
		accept: '.txt,.pdf,.docx,.doc,.xlsx,.xls',
		beforeUpload: handleFileUpload,
		onChange: handleFileUploadChange,
		showUploadList: true,
		maxCount: 1,
		listType: 'picture',
	};

	useEffect(() => {
		// Add the class to the body tag
		document.body.classList.add('shieldMaxxBG');
		// Clean up to remove the class when the component unmounts
		return () => {
			document.body.classList.remove('shieldMaxxBG');
		};
	}, []);
	return (
		<>
			<Col lg={24} xl={24} xs={0} md={0}>
				<Header headerTag="De-Identify" />
			</Col>
			<Col lg={0} xl={0} xs={24} md={24}>
				<HeaderFile activeNav="deidentify" />
			</Col>

			<XThemeContainer fluid>
				{isProcess ? (
					<XThemShieldDesktop>
						<Row
							gutter={[15, 15]}
							className="align-items-center mt-4"
						>
							<Col
								xs={{ span: 6, offset: 9 }}
								sm={{ span: 4, offset: 10 }}
								md={{ span: 4, offset: 10 }}
								lg={{ span: 4, offset: 10 }}
								className="text-center mb-3"
							>
								<XLottieShieldMaxx
									animationData={LoaderJson}
									loop={true}
								/>
							</Col>
							<Col xs={24} className="text-center">
								<XShieldMaxxTitle>Shield Maxx</XShieldMaxxTitle>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 8, offset: 8 }}
								className="text-center"
							>
								<ParaShieldMaxx>
									De-identify sensitive information from your
									text while preserving the content
								</ParaShieldMaxx>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 16, offset: 4 }}
								className="text-center mt-3"
							>
								<XTextAreaShieldMaxx
									rows={6}
									value={inputText}
									onChange={handleInputChange}
									placeholder="Enter text to de-identify..."
									disabled={isDisabled}
								/>
								<XTextAreaShieldMaxxBTN className="mainUpload">
									<div className="iconButtonLeft">
										<Upload
											{...uploadProps}
											onRemove={handleRemoveFile}
										>
											<LinkOutlined className="me-1" />{' '}
											Upload File
										</Upload>
									</div>
									<div className="iconButtonRight">
										<XTheme2Button
											shape="square"
											size="large"
											icon={<ArrowUpOutlined />}
											onClick={handleDeIdentify}
											loading={isProcessing}
											disabled={
												(!inputText &&
													!uploadedS3Url) ||
												isProcessing
											}
										/>
									</div>
								</XTextAreaShieldMaxxBTN>
							</Col>
							{/* <Col xs={24} className="text-center">
								<Space direction="horizontal" size={10}>
									<XShieldSuggestionBTN
										icon={
											<img
												src="/images/suggestion-icon.svg"
												alt=""
											/>
										}
									>
										Review pending cases
										<UpCircleTwoTone
											twoToneColor="rgba(26, 29, 35, 0.1)"
											className="ms-1"
										/>
									</XShieldSuggestionBTN>

									<XShieldSuggestionBTN
										icon={
											<img
												src="/images/suggestion-icon.svg"
												alt=""
											/>
										}
									>
										Review pending cases
										<UpCircleTwoTone
											twoToneColor="rgba(26, 29, 35, 0.1)"
											className="ms-1"
										/>
									</XShieldSuggestionBTN>

									<XShieldSuggestionBTN
										icon={
											<img
												src="/images/suggestion-icon.svg"
												alt=""
											/>
										}
									>
										Review pending cases
										<UpCircleTwoTone
											twoToneColor="rgba(26, 29, 35, 0.1)"
											className="ms-1"
										/>
									</XShieldSuggestionBTN>
								</Space>
							</Col> */}
						</Row>
					</XThemShieldDesktop>
				) : (
					<ParaShieldLeftScrollWrapper>
						<Row gutter={[15, 15]}>
							<Col xs={24} sm={24} md={8} lg={8}>
								<div className="header">
									<em>&nbsp;</em>
								</div>
								<div className="leftScrollData">
									{inputText && <p>{inputText}</p>}
									{uploadedS3Url && !inputText && (
										<p>
											File uploaded:{' '}
											{clinicalDocumentFileList[0]?.name}
										</p>
									)}
								</div>
								<div className="footer">
									<XTextAreaShieldMaxx
										className="smallChatBox"
										rows={4}
										placeholder="Re-enter text"
										onChange={handleInputChange}
										disabled={isDisabled}
										value={inputText}
									/>
									<XTextAreaShieldMaxxBTN className="innerUpload smallChatBox">
										<div className="iconButtonLeft">
											<Upload
												{...uploadProps}
												onRemove={handleRemoveFile}
											>
												<LinkOutlined className="me-1" />{' '}
												Upload File
											</Upload>
										</div>
										<div className="iconButtonRight">
											<XTheme2Button
												shape="square"
												size="large"
												icon={<ArrowUpOutlined />}
												onClick={handleDeIdentify}
												loading={isProcessing}
												disabled={
													(!inputText &&
														!uploadedS3Url) ||
													isProcessing
												}
											/>
										</div>
									</XTextAreaShieldMaxxBTN>
								</div>
							</Col>
							<Col xs={24} sm={24} md={16} lg={16}>
								<div className="header leftHeaderData">
									<Row gutter={[15, 15]}>
										<Col xs={24} sm={24} md={12} lg={12}>
											<div className="leftTitleAnimation">
												<XLottieShieldMaxx
													className="fullView"
													animationData={LoaderJson}
													loop={true}
												/>
											</div>
											Shield Maxx
										</Col>
										<Col
											xs={24}
											sm={24}
											md={12}
											lg={12}
											className="text-end"
										>
											<Space>
												<XTheme2Button
													className="noBackground"
													shape="square"
													size="large"
													onClick={() =>
														handleClear()
													}
													icon={
														<img
															src="/images/delete-shield-icon.svg"
															alt=""
														/>
													}
												/>
												<XTheme2Button
													shape="square"
													size="large"
													onClick={() =>
														handleCopy(
															deIdentifiedText,
														)
													}
													disabled={!deIdentifiedText}
													icon={
														<img
															src="/images/copy-icon.svg"
															alt=""
														/>
													}
												>
													Copy
												</XTheme2Button>
											</Space>
										</Col>
									</Row>
								</div>
								<div className="leftScrollData RightScrollData">
									{/* <div className="rightScrollDataTitle mb-3">
										Hello,
										<br />
										<span>
											Here is a summary of the
											De-Identified text.
										</span>
									</div> */}

									{isProcessing ? (
										<div className="mt-5 w-100 text-center">
											<XThemeShieldLoader className="loader1" />
											<p>Processing...</p>
										</div>
									) : (
										<>
											{deIdentifiedText && (
												<XShieldRightScrollCard>
													<p>{deIdentifiedText}</p>
												</XShieldRightScrollCard>
											)}
											{deIdentifiedUrl && (
												<XShieldRightScrollCard>
													<Space
														direction="vertical"
														align="center"
														style={{
															width: '100%',
														}}
													>
														<p>
															Your document has
															been de-identified
															successfully!
														</p>

														<XTheme2Button
															shape="square"
															size="large"
															onClick={() =>
																window.open(
																	deIdentifiedUrl,
																	'_blank',
																)
															}
															icon={
																<DownloadOutlined />
															}
														>
															Download
															De-identified
															Document
														</XTheme2Button>
													</Space>
												</XShieldRightScrollCard>
											)}
										</>
									)}
								</div>
							</Col>
						</Row>
					</ParaShieldLeftScrollWrapper>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	deIdentifyState: state.deIdentify,
});

const mapDispatchToProps = (dispatch) => ({
	deIdentify: (params) => dispatch(deIdentifyApi(params)),
	deIdentifyReset: () => dispatch(deIdentifyReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShieldMaxx);
